<template>
  <article class="project-card" :class="{ muted: !project.visible, uniform: uniformHeight }">
    <button type="button" class="project-link" @click="openProject">
      <div class="project-head">
        <span class="project-category">{{ project.category || 'Без категории' }}</span>
        <span class="project-status" :class="project.visible ? 'visible' : 'hidden'">
          {{ project.visible ? 'Виден' : 'Скрыт' }}
        </span>
      </div>

      <h3 class="project-title">{{ project.title || 'Без названия' }}</h3>

      <p v-if="previewDescription" class="project-description">
        {{ previewDescription }}
      </p>

      <div class="project-meta">
        <span v-if="project.date">{{ formatDate(project.date) }}</span>
        <span v-if="project.pin !== null && project.pin !== undefined">pin: {{ project.pin }}</span>
      </div>

      <span v-if="showOpenLabel" class="project-open">
        Открыть
        <span aria-hidden="true">→</span>
      </span>
    </button>

    <div v-if="hasActions" class="project-footer">
      <slot name="actions" />
    </div>
  </article>
</template>

<script>
export default {
  props: {
    project: Object,
    showProject: Function,
    showOpenLabel: {
      type: Boolean,
      default: true
    },
    uniformHeight: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    hasActions() {
      return Boolean(this.$slots.actions);
    },
    previewDescription() {
      const text = String(this.project?.content || '')
        .replace(/<[^>]*>/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
      return text ? text.slice(0, 120) : '';
    }
  },
  methods: {
    openProject() {
      if (typeof this.showProject === 'function' && this.project?.id !== undefined && this.project?.id !== null) {
        this.showProject(this.project.id);
      }
    },
    formatDate(date) {
      const parsed = new Date(date);
      if (Number.isNaN(parsed.getTime())) return '';
      return parsed.toLocaleDateString('ru-RU');
    }
  }
}
</script>

<style scoped>
.project-card {
  border: 1px solid hsl(var(--border));
  border-radius: 14px;
  background: hsl(var(--card));
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.project-card:hover {
  border-color: hsl(var(--accent) / 0.4);
  box-shadow: 0 16px 32px hsl(var(--foreground) / 0.1);
  transform: translateY(-1px);
}

.project-card.muted {
  opacity: 0.75;
}

.project-link {
  width: 100%;
  text-align: left;
  background: none;
  border: 0;
  padding: 14px;
  color: inherit;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1 1 auto;
}

.project-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.project-category {
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: hsl(var(--muted-foreground));
}

.project-status {
  font-size: 0.7rem;
  padding: 2px 8px;
  border-radius: 999px;
  border: 1px solid transparent;
}

.project-status.visible {
  background: hsl(var(--success) / 0.16);
  color: hsl(var(--success));
  border-color: hsl(var(--success) / 0.35);
}

.project-status.hidden {
  background: hsl(var(--destructive) / 0.12);
  color: hsl(var(--destructive));
  border-color: hsl(var(--destructive) / 0.32);
}

.project-title {
  margin: 0;
  font-size: 1.02rem;
  line-height: 1.35;
  font-weight: 700;
  color: hsl(var(--foreground));
}

.project-description {
  margin: 0;
  min-height: 2.5em;
  font-size: 0.85rem;
  line-height: 1.45;
  color: hsl(var(--muted-foreground));
}

.project-meta {
  display: flex;
  gap: 8px 14px;
  flex-wrap: wrap;
  font-size: 0.75rem;
  color: hsl(var(--muted-foreground));
}

.project-open {
  margin-top: auto;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.82rem;
  font-weight: 700;
  color: hsl(var(--accent));
}

.project-footer {
  border-top: 1px solid hsl(var(--border));
  padding: 10px 14px 12px;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  flex-wrap: wrap;
}

.project-card.uniform .project-title {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: calc(1.35em * 2);
}

.project-card.uniform .project-description {
  min-height: calc(1.45em * 3);
  max-height: calc(1.45em * 3);
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
